<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Pengagihan Embrio">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt3">
            <w-input style="margin:5px; "
               v-model="pencarian.tarikh"
               type="date"
               label="Tarikh Agihan"
               />
            
             <w-input style="margin:5px; "
               v-model="pencarian.nama_penerima"
               label="Nama Penerima"
               />
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
		  <z-table title="Senarai Pengagihan Embrio" :headers="table.headers" :items="table.items" :meta="table.meta">
        <template #button v-if="$zutil.anyRole(['1', '3', '4', '11'])">
                      <w-button dark v-on="on" class="green--bg ml1" :route="$route('embrio.pengagihan.form',0)" >
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
             <!--  <w-icon xs>fal fa-pencil</w-icon> -->
             TINDAKAN
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <!-- <inertia-link :href="$route('embrio.pengagihan.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
                <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
              </inertia-link> -->
            </w-flex><br>
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="fs-2" v-on="on" v-if="item.pendaftar==0 && ($zutil.anyRole(['1', '3', '11']))" bg-color="error-dark1" dark tile @click="destroy1(item.id)"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-trash</w-icon>
                </w-button>
                </template>
               PADAM
            </w-tooltip>
          </template>
           <template #item-cell.tarikh="{ item, label, header, index }">
              <w-flex class="flex justify-light">
                 {{ $zutil.dateformat(item.tarikh)}}
              </w-flex>
           </template>
		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'embrio.pengagihan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Pengagihan Embrio', route: '/embrio/pengagihan' },
      ],
      pencarian: {
         tarikh: '',
         nama_penerima: '',
         
      },
      tarikh: [],
      nama_penerima: [],
      
    }
  },
  methods: {
    // cetak() {
    //   window.location.href = window.route('se.pengagihan.index')+'?no_permohonan='+this.pencarian.no_permohonan+'&name='+this.pencarian.name+'&status='+this.pencarian.status+'&cetak=1';
    // },
    papar(items){
      this.getData(items)
      this.dialog.show = true
    },
    getData(items){
      if(items.id > 0){
        this.$zcomm.get(this.api_service + 'pengagihan/show/'+items.id, {}).then(res => {
          this.form = res

        })
      }
    },

    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },
    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
  
  },

  watch: {

  },
  mounted() {
    this.getKatalog();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
